export enum ReportsPermissions {
  VIEW_REPORTS = "view_reports",
  CREATE_REPORTS = "create_reports",
  UPDATE_REPORTS = "update_reports",
  DELETE_REPORTS = "delete_reports",
}

export const ReportsPermissionsText: Record<ReportsPermissions, string> = {
  [ReportsPermissions.VIEW_REPORTS]: "View Reports",
  [ReportsPermissions.CREATE_REPORTS]: "Create Reports",
  [ReportsPermissions.UPDATE_REPORTS]: "Update Reports",
  [ReportsPermissions.DELETE_REPORTS]: "Delete Reports",
};
